import api from './axios';
import { Category } from '../types';

export const categoriesApi = {
  getAll: () => api.get<Category[]>('/categories'),

  getById: (id: number) => api.get<Category>(`/categories/${id}`),

  create: (data: Partial<Category>) => api.post<Category>('/categories', data),

  update: (id: number, data: Partial<Category>) =>
    api.put<Category>(`/categories/${id}`, data),

  delete: (id: number) => api.delete(`/categories/${id}`),
};
